import actions from './actions'

export default function PostalCodesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_POSTALCODE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_POSTALCODE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_POSTALCODE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_POSTALCODE:
      return {
        ...state,
        editing: { id: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_POSTALCODE_RECIEVED ||
      actions.UPDATE_POSTALCODE_RECIEVED ||
      actions.DELETE_POSTALCODE_RECIEVED:
      return {
        ...state,
        editing: { id: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
